import { render, staticRenderFns } from "./LegacyTableActionDialog.vue?vue&type=template&id=129c10df&"
import script from "./LegacyTableActionDialog.vue?vue&type=script&lang=js&"
export * from "./LegacyTableActionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports